import * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { PersonDetailDataFragmentDoc } from '../editor.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type PersonQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type PersonQuery = {
  __typename?: 'Query';
  person: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export const PersonDocument = gql`
  query person($id: UUID!) {
    person(id: $id) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type PersonComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PersonQuery,
    PersonQueryVariables
  >,
  'query'
> &
  ({ variables: PersonQueryVariables; skip?: boolean } | { skip: boolean });

export const PersonComponent = (props: PersonComponentProps) => (
  <ApolloReactComponents.Query<PersonQuery, PersonQueryVariables>
    query={PersonDocument}
    {...props}
  />
);

/**
 * __usePersonQuery__
 *
 * To run a query within a React component, call `usePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonQuery(
  baseOptions: Apollo.QueryHookOptions<PersonQuery, PersonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PersonQuery, PersonQueryVariables>(
    PersonDocument,
    options,
  );
}
export function usePersonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PersonQuery, PersonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PersonQuery, PersonQueryVariables>(
    PersonDocument,
    options,
  );
}
export type PersonQueryHookResult = ReturnType<typeof usePersonQuery>;
export type PersonLazyQueryHookResult = ReturnType<typeof usePersonLazyQuery>;
export type PersonQueryResult = Apollo.QueryResult<
  PersonQuery,
  PersonQueryVariables
>;
